import { AnswerValueEnum } from "enums/enums";
import { itemNumber } from "features/game/logic/pagination.logic";
import { ListStepType } from "types/game";

export const suitValFunc = (suit: string) => {
  let suitVal = "";
  switch (suit) {
    case "heart":
      suitVal = "H";
      break;
    case "club":
      suitVal = "C";
      break;
    case "tiles":
      suitVal = "D";
      break;
    case "pikes":
      suitVal = "S";
      break;
    case "nt":
      suitVal = "NT";
      break;
    case "DBL":
      suitVal = "DBL";
      break;
    case "PASS":
      suitVal = "PASS";
      break;
    case "RDBL":
      suitVal = "RDBL";
      break;
  }
  return suitVal;
};

export const filterExercisePagination = (listExercise: any, type: string) => {
  const resLevels = localStorage.getItem("levels");
  const audit: number[] = [];

  if (resLevels && resLevels.length < 3) {
    const val = JSON.parse(resLevels);
    if (val?.ease) {
      audit.push(10);
    }
    if (val?.medium) {
      audit.push(20);
    }
    if (val?.hard) {
      audit.push(30);
    }
    if (type === "bidding" && audit.length > 0) {
      const exerciseBoofer: any[] = [];
      listExercise?.forEach((item) => {
        const findAudit = audit.find((item_audit) => item_audit === item?.Data?.Level);
        if (findAudit) {
          exerciseBoofer.push(item);
        }
      });
      return exerciseBoofer;
    } else if (audit.length > 0) {
      const exerciseBoofer: any[] = [];
      listExercise?.forEach((item) => {
        const findAudit = audit.find(
          (item_audit) => item_audit === item?.Data?.Level || item_audit === item?.Data?.ExLevel
        );
        if (findAudit) {
          exerciseBoofer.push(item);
        }
      });

      const booferArr: any[] = [];
      exerciseBoofer.forEach((item) => {
        let repeated = 0;
        booferArr.forEach((val) => {
          if (type === "tricks") {
            if (item?.Data?.Id === val?.Data?.Id) {
              repeated += 1;
            }
          } else if (type === "mini_bridge") {
            if (
              item?.Data?.ExIndex === val?.Data?.ExIndex &&
              item?.Data?.CategoryId === val?.Data?.CategoryId
            ) {
              repeated += 1;
            }
          } else {
            if (item?.Data?.Id_PHExercise === val?.Data?.Id_PHExercise) {
              repeated += 1;
            }
          }
        });

        if (repeated !== 1) {
          booferArr.push(item);
        }
      });
      return booferArr;
    } else {
      if (listExercise) {
        return listExercise;
      }
    }
  } else {
    if (listExercise) {
      return listExercise;
    }
  }
};

export const namePaginationList = (params, val, index, shuffle?: boolean) => {
  const typeBidding = params.get("typeBidding");
  return params.get("subject") === "true" || typeBidding === "mix" || typeBidding === "package" || shuffle
    ? index + 1
    : itemNumber(params.get("subject") === "true", val?.Data);
};

export const warningTextBidding = (isWrong) => {
  return isWrong ? "תשובתכם אינה נכונה, נסו שוב" : "";
};

export const isRdblFunc = (listSteps: ListStepType[][]) => {
  let isTrue = false;
  if (listSteps?.length) {
    listSteps.forEach((stepGroup: ListStepType[]) => {
      stepGroup.forEach((item: any) => {
        const value = item?.$?.Value;
        const stepValues = stepGroup.map((step) => step?.$?.Value?.toUpperCase());

        if (
          value === "?" &&
          (stepValues[2] === AnswerValueEnum.DBL ||
            (stepValues[2] === AnswerValueEnum.PASS &&
              stepValues[1] === AnswerValueEnum.PASS &&
              stepValues[0] === AnswerValueEnum.DBL))
        ) {
          isTrue = true;
        }
      });
    });
  }
  return isTrue;
};
